module.exports = __webpack_public_path__ + "img/1a70eb7.jpg";